/* Personalization Text Field */
if (!window.customElements.get('kl-personalization-field')) {
  window.customElements.define(
    'kl-personalization-field',
    class extends HTMLElement {
      connectedCallback() {
        this._abortController = new AbortController();

        const input = this.querySelector('input');
        const form = input && document.forms[input.getAttribute('form')];
        if (!form) return;

        form.addEventListener(
          'variant:change',
          (event) => {
            const variant = event.detail.variant;
            if (!variant) return;

            const selectedValue = variant['option' + this.dataset.optionPosition];
            const hide = selectedValue === this.dataset.firstValue;

            this.hidden = hide;
            input.disabled = hide;

            if (hide) {
              input.value = '';
            }
          },
          { signal: this._abortController.signal }
        );
      }

      disconnectedCallback() {
        this._abortController.abort();
      }
    }
  );
}
